import { Collapse } from '@mui/material'
import { ContentBox } from '../styled-components/ContentBox'

type CollapseItemsProps = {
  checked?: boolean
  children: React.ReactNode
}

export const CollapseItems = ({
  checked = false,
  children
}: CollapseItemsProps) => {
  return (
    <ContentBox>
      <Collapse in={checked}>{children}</Collapse>
    </ContentBox>
  )
}
